import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a704b42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-list-item__cell" }
const _hoisted_2 = { class: "session-list-item__cell" }
const _hoisted_3 = { class: "session-list-item__cell" }
const _hoisted_4 = {
  key: 0,
  class: "session-list-item__tooltip"
}
const _hoisted_5 = { class: "session-list-item__info-badge fw-bold" }
const _hoisted_6 = { class: "session-list-item__tooltip-text" }
const _hoisted_7 = {
  key: 1,
  class: "session-list-item__tooltip"
}
const _hoisted_8 = { class: "session-list-item__info-badge fw-bold" }
const _hoisted_9 = { class: "session-list-item__tooltip-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "session-list-item__end px-0 text-center" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "session-list-item__end px-0" }
const _hoisted_17 = { class: "session-list-item__end ps-0 pe-3" }
const _hoisted_18 = { class: "dropstart" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn p-0 rounded-0 border-0 kebab-button",
  "data-bs-toggle": "dropdown",
  "aria-label": "open session menu"
}, null, -1))
const _hoisted_20 = { class: "dropdown-menu p-0 rounded-0 border-0 shadow" }

import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import CheckCircleGrey from '@/icons/CheckCircleGrey.vue'
import CoachingSessionInfoModal from '../CoachingSessionInfoModal/CoachingSessionInfoModal.vue'
import DocumentDownloadModal from '../DocumentDownloadModal/DocumentDownloadModal.vue'
import { useClassroomStudentService } from '../ClassroomStudentService'
import { CourseTag } from '@/types/api'
import { downloadFile } from '@/utils/downloadFile'
import RecordingIcon from '@/icons/RecordingIcon.vue'
import DocumentIcon from '@/icons/DocumentIcon.vue'
import MultiTagIcon from '@/icons/icon_multitag.vue'


import { defineComponent, defineProps, ref } from 'vue'
const __default__ = defineComponent({
  name: 'PastSessionListItem'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    instructorName: {},
    disabled: { type: Boolean },
    isLastRow: { type: Boolean },
    eventTags: {},
    isLsat: { type: Boolean }
  },
  setup(__props: any) {

const props =
  __props

const classroomStudentService = useClassroomStudentService()
const dateString = props.modelValue.localStartDateTime.toLocaleString('en-us', {weekday: 'long', month: 'short', day: 'numeric', year: 'numeric'})
const hasDocuments = props.modelValue.event.documentFileNames?.length > 0
const showSessionInfo = ref(false)
const showDocumentDownloadModal = ref(false)
const documentsDownloading = ref([''])

function handleSessionInfoClick() {
  showSessionInfo.value = true
}

function handleDownloadDocuments() {
  if (props.modelValue.event.documentFileNames.length === 1) {
    downloadFiles([props.modelValue.event.documentFileNames[0]])
  } else {
    openDocumentDownloadModal()
  }
}
async function downloadFiles(fileNameList: string[]) {
  documentsDownloading.value = [ ...fileNameList ]
  try{
      await fileNameList.forEach(async (fileName) => {
        const file = await classroomStudentService.fetchEventDocument(props.modelValue.sessionId, fileName)
        if (file) {
          downloadFile(file, fileName)
          documentsDownloading.value = documentsDownloading.value.filter(f => f !== fileName)
        }
    })
  } catch (e) {
    documentsDownloading.value = []
    throw e
  }
}

function openDocumentDownloadModal() {
  showDocumentDownloadModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(['session-list-item text-secondary', {'grey-line': !_ctx.isLastRow}])
    }, [
      _createElementVNode("td", null, [
        (_ctx.modelValue.showRegistered)
          ? (_openBlock(), _createBlock(CheckCircleGrey, {
              key: 0,
              class: "checkmark-svg ms-3",
              role: "img",
              "aria-label": "currently enrolled session"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_1, _toDisplayString(_unref(dateString)), 1),
      _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.modelValue.localStartEndTime), 1),
      _createElementVNode("td", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.modelValue.event.title) + " ", 1),
        (_ctx.eventTags.length == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(_ctx.eventTags[0].abbreviation) + ") ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.eventTags[0].title), 1)
            ]))
          : (_ctx.eventTags.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(MultiTagIcon)
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _createTextVNode(" This course has multiple tags:"),
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventTags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag.abbreviation
                    }, [
                      _createTextVNode(_toDisplayString(tag.title) + " (" + _toDisplayString(tag.abbreviation) + ")" + _toDisplayString(tag == _ctx.eventTags[_ctx.eventTags.length - 1] ? '' : ','), 1),
                      _hoisted_11
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      (_ctx.isLsat)
        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.instructorName), 1))
        : (_openBlock(), _createElementBlock("td", _hoisted_13)),
      _createElementVNode("td", _hoisted_14, [
        (_ctx.modelValue.event.recordingLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "link-btn",
              href: _ctx.modelValue.event.recordingLink,
              target: "_blank"
            }, [
              _createVNode(RecordingIcon)
            ], 8, _hoisted_15))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_16, [
        hasDocuments
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn rounded-0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownloadDocuments()))
            }, [
              _createVNode(DocumentIcon)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "dropdown-item p-3 px-4 lh-base",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSessionInfoClick()))
            }, " Session" + _toDisplayString(_ctx.isLsat ? "/Instructor" : "") + " Info ", 1),
            hasDocuments
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "dropdown-item p-3 px-4 lh-base border-top",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleDownloadDocuments()))
                }, " Download Documents "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _createVNode(CoachingSessionInfoModal, {
      visible: showSessionInfo.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showSessionInfo).value = $event)),
      "coaching-session": _ctx.modelValue
    }, null, 8, ["visible", "coaching-session"]),
    _createVNode(DocumentDownloadModal, {
      visible: showDocumentDownloadModal.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showDocumentDownloadModal).value = $event)),
      "file-names": _ctx.modelValue.event.documentFileNames ?? [],
      "documents-downloading": documentsDownloading.value,
      onDownloadFiles: downloadFiles
    }, null, 8, ["visible", "file-names", "documents-downloading"])
  ], 64))
}
}

})